import { Component, NgZone, TemplateRef, ViewChild, ChangeDetectionStrategy } from "@angular/core";
import { AuthService } from "../../core/auth.service";
import { ActivatedRoute, Router } from "@angular/router";
import { TokenService } from "../../core/token.service";
import { ToastService } from "@app/services/toast.service";
import { NgxSpinnerService } from "ngx-spinner";
import { EncryptionService } from "../services/encryption.service";
import { FirebaseService } from "../services/firebase.service";

@Component({
    changeDetection: ChangeDetectionStrategy.Eager,
    selector: 'app-dealer-login',
    templateUrl: './dealer-login.component.html',
    styleUrl: './dealer-login.component.scss',})
export class DealerLoginComponent {


  token: any = null;
  pos_id: any = null;
  countdown = 5; // start at 5 seconds
  vas_opty_id: any = null;
  constructor(
    private authService: AuthService,
    private router: Router,
    private tokenService: TokenService,
    private toastr: ToastService,
    private spinner: NgxSpinnerService,
    public encryptionService: EncryptionService,
    private route: ActivatedRoute, private fs: FirebaseService,

  ) {

  }
  ngOnInit(): void {

    // Get the token from the query parameters (not route params)
    this.route.queryParams.subscribe(params => {
      this.token = params['q'];
      this.pos_id = params['pos_id'] ? params['pos_id'] : null; // Override with pos_id if available
      this.vas_opty_id = params['vas_opty_id'] ? params['vas_opty_id'] : null
      if (!this.token || !this.pos_id) {
        this.router.navigate(['/404']);
        return;
      }
      // Show spinner
      this.spinner.show('main');

      this.login();
    });
  }

  login(): void {
    this.authService.loginToDealer(this.token, this.vas_opty_id, this.pos_id).subscribe({
      next: (response) => {
        this.spinner.hide('main');

        // Save user info
        this.encryptionService.setToLocalStorage('position_type', response.data.user_info.position_type.toUpperCase());
        this.encryptionService.setToLocalStorage('position_name', response.data.user_info.position_name);
        this.encryptionService.setToLocalStorage('user_type', response.data.user_info.type.toLowerCase());
        this.encryptionService.setToLocalStorage('username', response.data.user_info.username);

        let tml_payment_active: boolean = response?.dealer_ac?.tml_payment_active ?? false;
        this.encryptionService.setToLocalStorage('tml_payment_active', tml_payment_active.toString());
        let amc_memi_active: boolean = response?.dealer_ac?.amc_memi_active ?? false;
        this.encryptionService.setToLocalStorage('amc_memi_active', amc_memi_active.toString());
        const dealerAc = response?.dealer_ac || {};
        this.encryptionService.setToLocalStorage('is_fms_active',(dealerAc.is_fms_active ?? false).toString());
        this.encryptionService.setToLocalStorage('is_ew_active',(dealerAc.is_ew_active ?? false).toString());
        this.encryptionService.setToLocalStorage('fms_memi_active',(dealerAc.fms_memi_active ?? false).toString());
        this.encryptionService.setToLocalStorage('fms_qemi_active',(dealerAc.fms_qemi_active ?? false).toString());
        this.encryptionService.setToLocalStorage('amc_qemi_active',(dealerAc.amc_qemi_active ?? false).toString());
        localStorage.setItem('isLogin', 'true');
        this.tokenService.saveToken(response.data.access_token);
        this.tokenService.saveRefreshToken(response.data.refresh_token);
        if (response?.data?.order_details) {
          // Group orders with stage info
          const redirectionOrders = this.groupOrdersWithStage(response?.data?.order_details);

          console.log('Redirection Orders:', redirectionOrders);

          // Count groups and singles
          const groupCount = redirectionOrders.filter((o: any) => o.is_group).length;
          const singleCount = redirectionOrders.filter((o: any) => !o.is_group).length;
          const totalCount = redirectionOrders.length;
          console.log(`Groups: ${groupCount}, Singles: ${singleCount}, Total: ${totalCount}`);
          // 👉 Simplified redirection logic
          if (totalCount === 1) {
            // Only one entry (group or single)
            this.navigateOrder(redirectionOrders);
          } else {
            if ((groupCount + singleCount) === 1) {
              // Only one group OR one single in the whole array
              this.navigateOrder(redirectionOrders);
            } else {
              // Multiple groups/singles → go to group-orders page
              this.router.navigate([`/dealer/group-orders/${this.vas_opty_id}`]);
            }
          }

        } else {
          this.router.navigate(['/dealer/pipeline/A0']);
        }
      },
      error: (err) => {
        this.spinner.hide('main');
        this.toastr.error(err?.error?.msg !== '' ? err?.error?.msg : 'Something went wrong, Please try again.');
        this.router.navigate(['/login']);
      }
    });
  }




  groupOrdersWithStage(data: any) {
    const stageMap = {
      A2: [
        "PRODUCT_SELECTION_PENDING", "KYC_PENDING", "EKYC_FAILED_SUBMIT_DOCUMENT_TO_TML",
        "KYC_VERIFICATION_PENDING", "KYC_NEEDS_CORRECTION", "KYC_VERIFIED"
      ],
      A3: [
        "PAYMENT_COLLECTION_PENDING", "PAYMENT_VERIFICATION_PENDING",
        "PAYMENT_DETAILS_NEEDS_CORRECTION", "PAYMENT_SUCCESSFUL"
      ],
      A4: [
        "CIF_CREATED", "CIF_ACCEPTANCE_PENDING", "CIF_VERIFICATION_PENDING",
        "CIF_NEEDS_CORRECTION", "CIF_ACCEPTED"
      ]
    };

    const grouped: any = {};
    const result: any = [];
    let orders = data.orders || [];

    // ✅ Handle case when orders array is empty
    if (orders.length === 0) {
      result.push({
        is_group: false,
        vas_opty_id: data.vas_opty_id || null,
        orders: [
          {
            order_number: null,
            group_order_number: null,
            order_status: null,
            order_stage: data.opty_stage || 'A0'
          }
        ]
      });
      return result;
    }

    orders.forEach((order: any) => {
      // Determine order_stage
      let orderStage = null;
      for (const [stage, statuses] of Object.entries(stageMap)) {
        if (statuses.includes(order.order_status)) {
          orderStage = stage;
          break;
        }
      }

      // 👉 New condition: if no order_number and no group_order_number → A0
      if (!order.order_number && !order.group_order_number) {
        orderStage = 'A0';
      }

      // Enrich order with stage
      const enrichedOrder = {
        ...order,
        order_stage: orderStage
      };

      if (order.group_order_number) {
        if (!grouped[order.group_order_number]) {
          grouped[order.group_order_number] = [];
        }
        grouped[order.group_order_number].push(enrichedOrder);
      } else {
        result.push({
          is_group: false,
          vas_opty_id: data.vas_opty_id || null,
          orders: [enrichedOrder]
        });
      }
    });

    // Push grouped arrays with is_group = true
    Object.keys(grouped).forEach(groupNo => {
      const groupOrders = grouped[groupNo];
      result.push({
        is_group: true,
        group_order_number: groupNo,
        vas_opty_id: groupOrders[0].vas_opty_id || null,
        orders: groupOrders
      });
    });

    return result;
  }



  navigateOrder(data: any) {
    let routePath = '';
    const group = data[0];
    const order = group.orders[0];

    // Decide which identifier to use
    const identifier = group.is_group ? group.group_order_number : order.order_number;

    switch (order.order_stage) {
      case 'A0':
      case 'A1':
        // Partial orders always use vas_opty_id
        routePath = `/dealer/partial-orders/${group.vas_opty_id}`;
        break;

      case 'A2':
        if (!group.is_group) {
          if (order.order_status === 'PRODUCT_SELECTION_PENDING') {
            routePath = `/dealer/order/enquiry-order/${identifier}`;
          } else {
            routePath = `/dealer/order/kyc-details/${identifier}`;
          }
        } else {
          routePath = `/dealer/group-orders/${identifier}`;
        }
        break;

      case 'A3':
        routePath = `/dealer/order/payment-details/${identifier}`;
        break;

      case 'A4':
        routePath = `/dealer/order/cif-details/${identifier}`;
        break;

      case 'A5':
        routePath = `/dealer/order/payment-details/${identifier}`; // later change to payment-emi
        break;

      case 'emi':
        routePath = `/dealer/order/emi-details/${identifier}`;
        break;

      case 'cancel':
      case 'lost':
        routePath = `/dealer/order/enquiry-order/${identifier}`;
        break;

      default:
        console.warn('Unknown stage:', order.order_stage);
        routePath = `/dealer/pipeline/A0`;
    }

    this.router.navigate([routePath]);
  }




}

